export default __webpack_public_path__ + "static/media/BP.ebe58931.svg";